webpackJsonp([7007137936868],{

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Example = __webpack_require__(33);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Example2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Optimistic Updates: Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore implements optimistic updating by default, meaning you have to exert effort to ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'turn if off'
	      ),
	      '. You can see it at work in ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples' },
	        'any of the examples in the lore repo'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you have an idea for an example that demonstrates or clarifies optimistic updating in a way not covered by one of the examples feel free to ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/issues' },
	        'create an issue to suggest it'
	      ),
	      '!'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-optimistic-updates-js-7eea54bfeca81fe550c6.js